// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"715f8a32","549":"1a43cce5","686":"3cfa3045","698":"3cfa3045"}[chunkId] + ".chunk.css";
};